module.exports = __webpack_public_path__ + "img/add-arrival-arrange-table-icon.7df3d245.svg";